import EmisionsWidget from './EmisionsWidget';

export default EmisionsWidget;
